const EMAIL = /[\w.+-]+@[\w-]+(\.[\w-]+)+/g;
const JWT   = /\beyJ[\w-]+\.[\w-]+\.[\w-]*/g;
const RFC   = /\b[A-ZÑ&]{3,4}\d{6}[A-Z\d]{3}\b/gi;
const CURP  = /\b[A-Z]{4}\d{6}[HM][A-Z]{5}[A-Z\d]\d\b/gi;
const DIGITS = /\d[\d\s-]{5,}\d/g;

/**
 * Quita de un texto lo que pueda identificar a alguien antes de mandarlo: correos, tokens, RFC,
 * CURP y tiras largas de dígitos (teléfonos, cuentas, folios). Es la red del cliente; el servidor
 * aplica la suya sobre las claves.
 */
export function scrubText (value: unknown, max = 80): string {
    if (typeof value !== 'string') return '';
    return value
        .replace(JWT, '•')
        .replace(EMAIL, '•')
        .replace(CURP, '•')
        .replace(RFC, '•')
        .replace(DIGITS, '•')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, max);
}

const QUOTED = /«[^»]*»|“[^”]*”|"[^"]*"|'[^']*'/g;

/**
 * Para textos de la interfaz armados con datos —«¿Eliminar a «Juan Pérez»?», «Se agregó "Bodega
 * Norte"»—: lo entrecomillado suele ser lo interpolado, así que se tapa entero antes de limpiar el
 * resto. Lo que queda dice qué pasó, no a quién.
 */
export function scrubCopy (value: unknown, max = 80): string {
    if (typeof value !== 'string') return '';
    return scrubText(value.replace(QUOTED, '«…»'), max);
}
